import { CatalogModel } from './catalog';
import { PersonFormContactsModel } from './personFormContacts';
import { PersonFormDocumentModel } from './personFormDocument';

export class InitPersonFormModel { 
    firstName?: string;
    secondLastName?: string;
    lastName?: string;
    secondName?: string;
    gender: CatalogModel;
    civilStatus: CatalogModel;
    birthDate: Date;
    contacts?: PersonFormContactsModel;
    document?: PersonFormDocumentModel;
    hasTaxObligationsOtherCountries?: boolean;
    isPep?: boolean;
    constructor(){
        this.firstName = null;
        this.secondLastName = null;
        this.lastName = null;
        this.secondName = null;
        this.gender = null;
        this.civilStatus = new CatalogModel();
        this.birthDate = null;
        this.contacts = new PersonFormContactsModel();
        this.document =  new PersonFormDocumentModel();
        this.hasTaxObligationsOtherCountries = false;
        this.isPep = false;
    }
}